import { useState } from "react"

import { Input, InputProps } from "antd"

export const PasswordInput = (props: InputProps) => {
  const [visible, setVisible] = useState(false)

  return (
    <Input.Password
      {...props}
      visibilityToggle={{
        visible,
        onVisibleChange: setVisible,
      }}
      autoComplete="new-password"
    />
  )
} 